import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Transaction } from '../restaurant-manager.models';

@Injectable({
    providedIn: 'root'
})
export class TransactionService {

    constructor(protected apiService: ApiService) { }

    getTransactionById(id: string): Observable<Transaction> {
        return this
            .apiService.get<Transaction>('/transactions/' + id, true)
            .pipe(map(result => new Transaction(result)));
    }

    getLatestTransactionByOrderId(id: string): Observable<Transaction> {
        return this
            .apiService.get<Transaction>('/transactions/orders/' + id + '/latest', true)
            .pipe(map(result => new Transaction(result)));
    }

    markAsPaid(data: string[]): Observable<any> {
        return this.apiService.put<any>('/transactions/pay', {ids: data}, true);
    }

}
